import { Point } from '@flatten-js/core';
export default class HeightPoint {
  x = 0;
  y = 0;
  _height = 0;
  tempHeight = 0;
  isInitial = true;
  _finished = false;
  _highlighted = false;

  constructor(json = {}) {
    ({
      x: this.x,
      y: this.y,
      height: this.height = 0,
      is_initial: this.isInitial = true,
      parent: this.parent,
      finished: this._finished = false,
      initialMinHeight: this.initialMinHeight,
    } = json);
    if (!this.parent) {
      console.error('Parent area was not provided for the height point');
    }
  }

  set height(value) {
    this._height = Number.parseInt(value);
  }

  get height() {
    return this._height;
  }

  set finished(finished) {
    this._finished = finished;
  }

  set isMinHeight(isMinHeight) {
    this._isMinHeight = isMinHeight;
  }

  get isMinHeight() {
    return this._isMinHeight;
  }

  get flattenPoint() {
    return new Point(this.x, this.y);
  }

  get flattenPointInMm() {
    return new Point(this.x * 10, this.y * 10);
  }

  get finished() {
    return this._finished;
  }

  get backendObject() {
    return {
      x: this.x,
      y: this.y,
      height: this.height,
      is_initial: this.isInitial,
    };
  }

  get highlighted() {
    return this._highlighted;
  }

  set highlighted(highlighted) {
    this._highlighted = highlighted;
  }
}
